import React from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer
} from 'recharts';

interface Props {
  distribution: { [key: string]: number };
}

const MemberDistribution: React.FC<Props> = ({ distribution }) => {
  const data = Object.entries(distribution).map(([name, count]) => ({
    name,
    count
  }));

  return (
    <div className="stats-card hover:border-primary-500/20 group">
      <div className="p-6 space-y-4">
        <h2 className="text-xl font-medium text-gray-900 dark:text-white">
          Organization Members
        </h2>
        <div className="h-[300px]">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={data} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis 
                dataKey="name" 
                angle={-45}
                textAnchor="end"
                height={70}
                interval={0}
                className="text-xs"
              />
              <YAxis />
              <Tooltip />
              <Bar dataKey="count" fill="#6366f1" />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
};

export default MemberDistribution;
